import { Group, Stack, Text, Title } from "@mantine/core";
import type { ReactNode } from "react";

interface HeroProps {
  children?: ReactNode;
  subtitle?: string;
  title?: string;
}

/**
 * Hero renders the {% hero %} tag as a prominent landing header: a large title,
 * an optional subtitle, and a call-to-action row drawn from the body.
 */
export const Hero = ({ children, subtitle, title }: HeroProps) => (
  <Stack gap="sm" mb="xl" mt="lg">
    {title ? <Title order={1}>{title}</Title> : null}
    {subtitle ? (
      <Text c="dimmed" size="xl">
        {subtitle}
      </Text>
    ) : null}
    {children ? (
      <Group gap="sm" mt="md">
        {children}
      </Group>
    ) : null}
  </Stack>
);
